import { useWatch } from 'react-hook-form';
import { isEmpty } from 'lodash';
import { CreateLicensorsForm } from '../createLicensors/CreateLicensorsForm';
import { CreateEmptyState } from './CreateEmptyState';

export function CreateContent({ fields, remove }) {
  const rightsOwners = useWatch({ name: 'rightsOwners' });

  return (
    <>
      <CreateLicensorsForm fields={fields} remove={remove} />
      {
      isEmpty(rightsOwners) && <CreateEmptyState />
     }
    </>
  );
}
